import React from 'react'
import Home from '../pages/Home'
import Cart from '../pages/Cart'
import Checkout from '../pages/Checkout'
import Login from '../pages/Login'
import ProductDetails from '../pages/ProductDetails'
import Signup from '../pages/Signup'
import Shop from '../pages/Shop'
import ProtectedRoute from './ProtectedRoute'

import BoardAddProduct from '../admin/BoardAddProduct'
import BoardAllProducts from '../admin/BoardAllProducts'
import Dashboard from '../admin/Dashboard'
import User from '../admin/User'


import { Route,Routes ,Navigate} from 'react-router-dom'




const Routers = () => {
    return (
        <Routes>
            <Route path='/' element={<Navigate to="home" />}/>
            <Route path='home' element={<Home />}/>
            <Route path='cart' element={<Cart />}/>
            {/* <Route path='checkout' element={
                <ProtectedRoute>
                    <Checkout />
                </ProtectedRoute>}/> */}
            <Route path='login' element={<Login />}/>
            <Route path='shop/:id' element={<ProductDetails />}/>
            <Route path='signup' element={<Signup />}/>
            <Route path='shop' element={<Shop />}/>
            <Route path='*' element={<ProtectedRoute />}>

                <Route path='checkout' element={<Checkout />}/>
                <Route path='dashboard/add-product' element={<BoardAddProduct />}/>
                <Route path='dashboard' element={<Dashboard />}/>
                <Route path='dashboard/all-products' element={<BoardAllProducts />}/>
                <Route path='dashboard/users' element={<User />}/>

            </Route>
        </Routes>
    )
}

export default Routers